export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9285.c6912073.jpg";